import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getCashPaymentsAccounts,
  cashPaymentsAccountsListSuccessful,
  cashPaymentsAccountsAddSuccessful,
  isModelVisible,
} from "./cashPaymentsAccountsSlice";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";
// AUTH related methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";

function* FetchCashPaymentsAccounts({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/cashpaymentaccounts/", params);
    yield put(cashPaymentsAccountsListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* AddCashPaymentsAccounts({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/cashpaymentaccounts/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Country Add Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getCashPaymentsAccounts({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to added Country. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(cashPaymentsAccountsAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/cashpaymentaccounts/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Country Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getCashPaymentsAccounts({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Country. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(cashPaymentsAccountsAddSuccessful(null));
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeleteCashPaymentsAccounts({ payload }) {
  var cashPaymentsAccountsID = payload;
  try {
    const response = yield call(postDelete, "/masters/cashpaymentaccounts/" + cashPaymentsAccountsID);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Cash Payments Accounts has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getCashPaymentsAccounts({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Country has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

export function* watchgetCashPaymentsAccounts() {
  yield takeEvery("cashpaymentsaccounts/getCashPaymentsAccounts", FetchCashPaymentsAccounts);
}
export function* watchCashPaymentsAccountsAdd() {
  yield takeEvery("cashpaymentsaccounts/cashPaymentsAccountsAdd", AddCashPaymentsAccounts);
}

export function* watchCashPaymentsAccountsDelete() {
  yield takeEvery("cashpaymentsaccounts/cashPaymentsAccountsDelete", DeleteCashPaymentsAccounts);
}

function* CashPaymentsAccountsSaga() {
  yield all([
    fork(watchgetCashPaymentsAccounts),
    fork(watchCashPaymentsAccountsAdd),
    fork(watchCashPaymentsAccountsDelete),
  ]);
}

export default CashPaymentsAccountsSaga;
